import {Text} from '@shopify/polaris';
export default function ReturnLabelDetails({labels}:{labels:{serial?:string|null;lot?:string|null;expiry?:string|null}}){
 const text=[labels.serial&&'Serial: '+labels.serial,labels.lot&&'Batch: '+labels.lot,labels.expiry&&'Expiry: '+labels.expiry].filter(Boolean).join(' · ');
 return text?<div style={{overflowWrap:'anywhere'}}><Text as="p">{text}</Text></div>:null;
}
